<app-admin-form [title]="settings?.Title" [object]="settings" [withSettingsSelector]="true"
  (settingsChanged)="settings=$event" [saveAction]="adminSettingsService.saveSettingsBase(settings)">

  <app-admin-admin-setting *ngFor="let setting of adminSettingsService.getAdminSettings(settings)"
    [adminSetting]="adminSettingsService.getAdminSetting(settings, setting.Key)"
    [dividerKind]="isModal()?1:0"></app-admin-admin-setting>

</app-admin-form>